import Vue from 'vue';
import jQuery from 'jquery';

Vue.use({
    install: function (Vue, options) {
      // Vue.prototype.$jQuery = jQuery; // you'll have this.$jQuery anywhere in your vue project
      const $ = jQuery;
      window.$ = $;
      window.jQuery = jQuery;
    }
  });
